module.exports = __webpack_public_path__ + "img/water_droplet_1.038936b5.svg";